import {Chart as ChartJS, ChartEvent, LegendItem} from 'chart.js'

import {roundValue} from '../../../../plantMonitoring/shared/utils/sensor.utils'

export const chartTooltip = {
  borderWidth: 0.5,
  bodySpacing: 5,
  boxPadding: 3,
  cornerRadius: 8,
  position: 'nearest',
  usePointStyle: true,
  padding: 15,
  backgroundColor: '#171f26'
} as const

export const chartLegend = {
  display: true,
  align: 'start' as const,
  onClick: (_: ChartEvent, legendItem: LegendItem, legend: {chart: ChartJS}) => {
    const chart = legend.chart
    const clickedLabel = legendItem.text

    if (clickedLabel.toLowerCase() === 'model') {
      chart.data.datasets.forEach((dataset, i) => {
        if (dataset.label && dataset.label.toLowerCase().includes(clickedLabel.toLowerCase())) {
          const meta = chart.getDatasetMeta(i)
          meta.hidden = !meta.hidden ? chart.isDatasetVisible(i) : false
        }
      })
    } else if (legendItem.datasetIndex !== undefined) {
      const meta = chart.getDatasetMeta(legendItem.datasetIndex)
      meta.hidden = !meta.hidden ? chart.isDatasetVisible(legendItem.datasetIndex) : false
    }
    chart.update()
  },
  labels: {
    usePointStyle: true,
    pointStyle: 'circle',
    font: {size: 16, weight: 'bold', family: 'Inter, sans-serif'},
    color: '#00274D',
    boxHeight: 8,
    filter: (legendItem) => legendItem.text !== 'modelMin' && legendItem.text !== 'modelMax'
  },
  onHover(e) {
    if (!e?.native?.target) return
    e.native.target.style.cursor = 'pointer'
  },
  onLeave(e) {
    if (!e?.native?.target) return
    e.native.target.style.cursor = 'default'
  }
} as const

export const getTooltipLabel = ({
  label,
  unit,
  value
}: {
  label: string | undefined
  unit: string | undefined
  value: number | undefined | null
}) => {
  const formattedValue =
    value !== null && value !== undefined ? `${roundValue(value)} ${unit}` : '-'
  return label ? `${label}: ${formattedValue}` : formattedValue
}

export const commonTimeConfig = (isUsFormat: boolean) =>
  ({
    minUnit: 'minute',
    displayFormats: {
      minute: isUsFormat ? 'h:mm A' : 'H:mm',
      hour: isUsFormat ? 'h A' : 'H:mm'
    },
    tooltipFormat: isUsFormat ? 'MM/DD/YYYY h:mm A' : 'DD.MM.YYYY HH:mm'
  }) as const

export const commonTicksConfig = {
  source: 'auto',
  padding: 10,
  autoSkip: true,
  autoSkipPadding: 25,
  minRotation: 10,
  maxRotation: 40,
  sampleSize: 20,
  major: {
    enabled: true
  },
  font: (context) => {
    return context?.tick?.major ? {weight: 700} : {}
  }
} as const
